import { submitForm } from "../../services/api";
import { formatCardTokenResponse } from "./utils";

export const sdkCreateCardToken = async ({
  cardIntentId,
  cardEmbed = {},
  lang,
}: {
  cardIntentId: string;
  providerId: string;
  paymentMethod: string;
  billingData: Record<string, string>;
  shippingData: Record<string, string>;
  cardEmbed: Record<string, unknown>;
  lang: string;
}) => {
  const { cardValidation, ...restCardEmbed } = cardEmbed;

  const response = (await submitForm({
    tokenizeCard: true,
    intentID: cardIntentId,
    lang,
    data: {
      ...restCardEmbed,
      card_validation: cardValidation,
      save_card: true,
    },
  })) as unknown as CardApiResponse;
  return formatCardTokenResponse(response);
};
